export default __webpack_public_path__ + "static/media/second.52e4fa9a.svg";